/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { sandboxRunCode } from "../../funcs/sandboxRunCode.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.RunCodeRequest$inboundSchema,
};

export const tool$sandboxRunCode: ToolDefinition<typeof args> = {
  name: "sandbox-run-code",
  description: `Run Code

Execute source code in the session workspace using a supported runtime and return the execution result.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await sandboxRunCode(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
